import React from 'react';

const Card = ({ children, className = "", ...props }) => (
  <div {...props} className={`bg-white dark:bg-gray-800 ${!className.includes('-card') ? 'rounded-2xl' : ''} border border-gray-100 dark:border-gray-700 shadow-sm ${className}`}>{children}</div>
);

export default Card;